<template>
    <modal :adaptive="true" height="auto" name="network_programs" @before-open="beforeOpen" style="z-index: 1071">
        <network-program-modal @programEventUpdated="onProgramEventUpdated"/>
        <d-card>
            <d-card-body>
                <h6 v-if="affiliateNetworkAccount" class="card-title">
                    {{affiliateNetworkAccount.affiliateNetwork.human_readable_name}} program settings
                </h6>
                <v-client-table class="dataTables_wrapper domain-table" ref="programEvents"
                                :data="programAnalyticEvents" :columns="columns" :options="clientTableOptions">
                    <d-col slot="event_name" slot-scope="props" size="small">
                        <span>{{props.row.event_name || 'purchase'}}</span>
                    </d-col>
                    <d-col slot="edit" slot-scope="props" size="small">
                        <i class="fa fa-pencil" @click="showNetworkProgramModal(props.row)"/>
                    </d-col>
                </v-client-table>
            </d-card-body>
            <d-card-footer class="d-flex justify-content-end">
                <button type="button" @click="hideModal()" class="btn btn-secondary">
                    Close
                </button>
            </d-card-footer>
        </d-card>
    </modal>
</template>

<script>
  import moment from 'moment'
  import notification from '@/mixins/notification';
  import {PerformanceService, AffiliateNetworkService} from "@/main";
  import NetworkProgramModal from '@/components/network/NetworkProgramModal.vue';

  export default {
    mixins: [notification],
    components: {
      NetworkProgramModal
    },

    data() {
      return {
        affiliateNetworkAccount: null,
        programAnalyticEvents: [],
        programNames: [],
        columns: ['program_name', 'event_name', 'edit'],
        clientTableOptions: {
          perPage: 25,
          pagination: {show: false},
          childRowTogglerFirst: false,
          recordsPerPage: [25, 50, 100],
          skin: 'table dataTable',
          filterable: false,
          headings: {
            'edit': ''
          }
        },
      };
    },
    methods: {
      async getAdvertiserNames(affiliateNetworkId) {
        const dateFrom = moment().subtract(90, 'days').format('YYYY-MM-DD');
        this.programNames = await PerformanceService.getAdvertiserNames(affiliateNetworkId, dateFrom);
        this.programAnalyticEvents = this.programNames.map(name => {
          const analyticEvent = this.affiliateNetworkAccount.affiliateNetworkProgramAnalyticsEvents.find(e => e.program_name === name)
          const eventParams = analyticEvent ? analyticEvent.event_params : []
          return {
            id: analyticEvent ? analyticEvent.id : null,
            program_name: name,
            event_name: analyticEvent ? analyticEvent.event_name : null,
            affiliate_network_account_id: this.affiliateNetworkAccount.id,
            event_params: eventParams.map((p) => {
              return {key: p.key, value: p.value}
            })
          };
        });
      },

      showNetworkProgramModal(networkProgram) {
        this.$modal.show('network_program', {networkProgram});
      },

      hideModal() {
        this.$modal.hide('network_programs');
      },

      onProgramEventUpdated(programEvent) {
        const index = this.programAnalyticEvents.findIndex((e) => {
          return e.affiliate_network_account_id === programEvent.affiliate_network_account_id && e.program_name === programEvent.program_name
        })

        this.programAnalyticEvents.splice(index, 1, programEvent)

        AffiliateNetworkService.setProgramEvent(programEvent)
        this.showNotification('success', 'Alert', 'Success')
      },

      beforeOpen(event) {
        this.affiliateNetworkAccount = event.params.affiliateNetworkAccount
        this.getAdvertiserNames(this.affiliateNetworkAccount.affiliateNetwork.id)
      }
    }
  };
</script>
